import React, { useId } from 'react'
import { Circle, Defs, LinearGradient, Stop, Svg } from 'react-native-svg'
import { IconProps } from '@tabler/icons-react-native'
import { getGradientBreakpoint, linearGradientProps } from '../utils'
import { ColorConfig, opacityToDecimal } from '@ca/common/types'

export interface AttributeColorProps extends IconProps {
  colorConfig: ColorConfig
}

const defaultBackColors = [
  {
    color: '#ffffff',
    opacity: 100,
  },
]

export default function AttributeColor({
  colorConfig,
  size = 24,
  ...props
}: AttributeColorProps) {
  const front = colorConfig.front
  const back =
    colorConfig.back && colorConfig.back.length > 0
      ? colorConfig.back
      : defaultBackColors

  const id = useId()

  return (
    <Svg width={size} height={size} viewBox="0 0 64 64" fill="none" {...props}>
      {/* <Circle cx="32" cy="32" r="32" fill="white" /> */}
      <Circle cx="32" cy="32" r="32" fill={`url(#tinting-color-${id}-back)`} />
      <Circle
        cx="32"
        cy="32"
        r="32"
        fill={`url(#tinting-color-${id}-front)`}
        // {...stokeProps}
      />
      <Defs>
        <LinearGradient
          id={`tinting-color-${id}-back`}
          {...linearGradientProps}
        >
          {back.map((color, index) => (
            <Stop
              key={index}
              stopColor={color.color}
              stopOpacity={opacityToDecimal(color.opacity)}
              offset={getGradientBreakpoint(index, back.length)}
            />
          ))}
        </LinearGradient>
        <LinearGradient
          id={`tinting-color-${id}-front`}
          {...linearGradientProps}
        >
          {front.map((color, index) => (
            <Stop
              key={index}
              stopColor={color.color}
              stopOpacity={opacityToDecimal(color.opacity)}
              offset={getGradientBreakpoint(index, front.length)}
            />
          ))}
        </LinearGradient>
      </Defs>
    </Svg>
  )
}
